/**
 * Visibility of the Guides "Tutorial Videos" surface — i.e. the hub card on
 * `/guides` and the `/guides/videos` page. This is the single switch that
 * controls who (if anyone) can see that surface.
 *
 * - "hidden": not shown to anyone. The hub card is removed and `/guides/videos`
 *   redirects back to `/guides`.
 * - "admin":  visible to admins only (gated server-side + client-side).
 * - "public": visible to everyone.
 *
 * NOTE: this flag does NOT affect the admin upload/management UI in
 * Admin → Site Settings → Tutorial Videos, or the underlying data/API — those
 * stay active regardless, so videos can keep being curated before launch.
 */
export type TutorialVideosVisibility = "hidden" | "admin" | "public";

// `as` (not `as const`) keeps the type widened to the union so the derived
// flags below type-check; change the value to flip the surface on/off.
export const TUTORIAL_VIDEOS_VISIBILITY = "hidden" as TutorialVideosVisibility;

export const TUTORIAL_VIDEOS_HIDDEN = TUTORIAL_VIDEOS_VISIBILITY === "hidden";
export const TUTORIAL_VIDEOS_ADMIN_ONLY = TUTORIAL_VIDEOS_VISIBILITY === "admin";
export const TUTORIAL_VIDEOS_PUBLIC = TUTORIAL_VIDEOS_VISIBILITY === "public";
